/** biome-ignore-all lint/suspicious/noExplicitAny: error boundary sends any */

import {ErrorBoundary as AppSignalErrorBoundary} from '@appsignal/react';
import {type ReactNode} from 'react';
import {FallbackComponent} from '~/common/components/ErrorBoundary/FallbackComponent';
import {appsignal} from '~/common/global';
import {getTags} from '~library/utils/evite/tagging';

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: (error: any) => ReactNode;
  componentName: string;
}

export const ErrorBoundary = ({children, fallback, componentName}: ErrorBoundaryProps) => {
  const Fallback = fallback || FallbackComponent;
  const tags = getTags();
  tags.unexpected = 'unexpected_true';

  return (
    <AppSignalErrorBoundary
      instance={appsignal}
      action={componentName}
      fallback={(error: any) => <Fallback error={error} />}
      tags={tags}
    >
      {children}
    </AppSignalErrorBoundary>
  );
};
